export default __webpack_public_path__ + "static/media/grafema_ciceco_09.63a3911e.jpg";